var _ellipse, _rect, _circle, _circle2, _rect2, _rect3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFailedCreditCard = function SvgFailedCreditCard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 59.8283,
    cy: 104.75,
    rx: 37.321,
    ry: 1.99934,
    fill: "url(#paint0_linear_316_31988)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.746,
    y: 44.7578,
    width: 46.6513,
    height: 74.642,
    rx: 7.08069,
    transform: "rotate(108.2 102.746 44.7578)",
    fill: "url(#paint1_linear_316_31988)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5573,
    cy: 72.2055,
    r: 5.99802,
    transform: "rotate(108.2 71.5573 72.2055)",
    fill: "#F8C0C0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4209,
    cy: 75.1195,
    r: 5.99802,
    transform: "rotate(108.2 80.4209 75.1195)",
    fill: "#F8C0C0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5076,
    y: 31.5742,
    width: 74.642,
    height: 9.33025,
    transform: "rotate(18.1998 28.5076 31.5742)",
    fill: "#EF9A9A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5625,
    y: 14.375,
    width: 7.98611,
    height: 20.7639,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5142 29.3479L43.5137 29.347L33.292 10.9479C31.7292 8.13125 29.3257 6.18945 26.3541 6.18945C23.3827 6.18945 20.9794 8.13086 19.4167 10.947C19.4165 10.9473 19.4163 10.9476 19.4162 10.9479L9.19443 29.347L9.19442 29.347L9.19141 29.3525C7.69977 32.0595 7.3586 35.013 8.8153 37.5006C10.2747 39.9927 13.0337 41.1367 16.1318 41.1367L36.5763 41.1367C39.6745 41.1367 42.4335 39.9927 43.8928 37.5006C45.3487 35.0144 45.0101 32.0442 43.5142 29.3479Z",
    fill: "#EF5350",
    stroke: "white",
    strokeWidth: 3.59375
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_31988",
    x1: 105.631,
    y1: 103.018,
    x2: 103.899,
    y2: 117.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_31988",
    x1: 102.746,
    y1: 65.1955,
    x2: 146.511,
    y2: 96.7453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE4E4"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFailedCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "failed-credit-card.f0022d0b47742ccfb79ec62806247982.svg";